<template>
  <el-dialog
    :title="$t('addMenuGroup.addMenuGroup')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose">
    <el-form :model="addMenuGroupInfo" :rules="rules" ref="addForm">
      <el-form-item :label="$t('addMenuGroup.groupName')" prop="name">
        <el-input 
          v-model="addMenuGroupInfo.name" 
          :placeholder="$t('addMenuGroup.requiredGroupName')">
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('addMenuGroup.icon')" prop="icon">
        <el-input 
          v-model="addMenuGroupInfo.icon" 
          :placeholder="$t('addMenuGroup.requiredIcon')">
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('addMenuGroup.label')">
        <el-select 
          v-model="addMenuGroupInfo.label" 
          style="width:100%"
          :placeholder="$t('addMenuGroup.optionalLabel')">
          <el-option value="" :label="$t('addMenuGroup.optionalLabel')"></el-option>
          <el-option value="HOT" label="HOT"></el-option>
          <el-option value="TOP" label="TOP"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('addMenuGroup.sequence')" prop="seq">
        <el-input 
          v-model="addMenuGroupInfo.seq" 
          :placeholder="$t('addMenuGroup.requiredSequence')">
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('addMenuGroup.groupType')">
        <el-select 
          v-model="addMenuGroupInfo.groupType" 
          style="width:100%"
          :placeholder="$t('addMenuGroup.optionalGroupType')">
          <el-option value="" disabled :label="$t('addMenuGroup.optionalGroupType')"></el-option>
          <el-option value="P_WEB" :label="$t('addMenuGroup.web')"></el-option>
          <el-option value="P_APP" :label="$t('addMenuGroup.app')"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('addMenuGroup.storeType')">
        <el-select 
          v-model="addMenuGroupInfo.storeType" 
          style="width:100%"
          :placeholder="$t('addMenuGroup.selectStoreType')">
          <el-option value="" :label="$t('addMenuGroup.selectStoreType')"></el-option>
          <el-option value="800900000001" :label="$t('addMenuGroup.operationTeam')"></el-option>
          <el-option value="800900000005" :label="$t('addMenuGroup.merchant')"></el-option>
          <el-option value="800900000000" :label="$t('addMenuGroup.developmentTeam')"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('addMenuGroup.description')">
        <el-input
          type="textarea"
          :rows="2"
          :placeholder="$t('addMenuGroup.optionalDescription')"
          v-model="addMenuGroupInfo.description">
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{$t('common.cancel')}}</el-button>
      <el-button type="primary" @click="saveMenuGroupInfo">{{$t('common.save')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveMenuGroup } from '@/api/dev/menuGroupApi'

export default {
  name: 'AddMenuGroup',
  data() {
    return {
      dialogVisible: false,
      addMenuGroupInfo: {
        name: '',
        icon: '',
        label: '',
        seq: '',
        description: '',
        groupType: '',
        storeType: ''
      },
      rules: {
        name: [
          { required: true, message: this.$t('addMenuGroup.groupNameRequired'), trigger: 'blur' },
          { min: 2, max: 10, message: this.$t('addMenuGroup.groupNameLength'), trigger: 'blur' }
        ],
        icon: [
          { required: true, message: this.$t('addMenuGroup.iconRequired'), trigger: 'blur' },
          { min: 2, max: 20, message: this.$t('addMenuGroup.iconLength'), trigger: 'blur' }
        ],
        seq: [
          { required: true, message: this.$t('addMenuGroup.sequenceRequired'), trigger: 'blur' },
          { pattern: /^\d+$/, message: this.$t('addMenuGroup.sequenceNumber'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
    },
    handleClose() {
      this.$refs.addForm.resetFields()
      this.addMenuGroupInfo = {
        name: '',
        icon: '',
        label: '',
        seq: '',
        description: '',
        groupType: '',
        storeType: ''
      }
    },
    async saveMenuGroupInfo() {
      try {
        await this.$refs.addForm.validate()
        await saveMenuGroup(this.addMenuGroupInfo)
        this.$message.success(this.$t('addMenuGroup.addSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        if (error !== 'validate') {
          this.$message.error(error.message || this.$t('addMenuGroup.addFailed'))
        }
      }
    }
  }
}
</script>